import { render, staticRenderFns } from "./subsidiaryList.vue?vue&type=template&id=4c5b2e70&scoped=true&"
import script from "./subsidiaryList.vue?vue&type=script&lang=js&"
export * from "./subsidiaryList.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryList.vue?vue&type=style&index=0&id=4c5b2e70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b2e70",
  null
  
)

export default component.exports